<template>
  <div class="app-container">
    <!-- <el-form ref="queryForm"
             :model="queryParams"
             :inline="true"
             label-width="68px">
      <el-form-item label="商品名称"
                    prop="operName">
        <el-input v-model="queryParams.prodName"
                  placeholder="请输入操作账号"
                  clearable
                  size="small" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary"
                   icon="el-icon-search"
                   :loading="loading"
                   size="mini"
                   @click="handleQuery">查询</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form> -->
    <!-- <div class="gap">
      <span>我的等级： {{ score/10 <0 ?" 0":score/10 }} 级</span>
        <el-button type="primary"
                   size="mini"
                   @click="logout">退出</el-button>
    <el-row :gutter="10"
            class="mb8">
      <el-col :span="1.5">
        <el-button type="primary"
                   icon="el-icon-plus"
                   size="mini"
                   @click="handleAdd">新增</el-button>
      </el-col>
    </el-row>
   
  </div> -->
  <div class="gap"></div>
    <el-table v-loading="loading"
              :data="list">
      <!-- <el-table-column type="selection" width="55" align="center" /> -->
      <!-- <el-table-column label="日志编号" align="center" prop="operId" /> -->
      <!-- <el-table-column label="产品图片"
                       align="center"
                       prop="img">
         <template slot-scope="scope">
          <img style="width:100px"
               :src="scope.row.img"
               alt="" />
        </template>
      </el-table-column> -->
      <el-table-column label="订单编号"
      label-class-name  = 'title'
                       align="center"
                      :formatter="transOrder"
                       prop="id" />
      <el-table-column label="年级"
      label-class-name  = 'title'
                       align="center"
                       prop="grade" />
      <el-table-column label="手机号码"
                       align="center"
                        label-class-name  = 'title'
                       prop="phone" />
      <el-table-column label="学员性别"
                       align="center"
                        label-class-name  = 'title'
                       :formatter ='transGender'
                       prop="gender" />
      <el-table-column label="学员年级"
                       align="center"
                        label-class-name  = 'title'
                       :formatter="transGrade"
                       prop="grade" />
      <el-table-column label="辅导科目"
                       align="center"
                        label-class-name  = 'title'
                       prop="kemu" />
      <el-table-column label="上课时间"
                       align="center"
                        label-class-name  = 'title'
                       prop="class_time" />
      <el-table-column label="上课地址"
                       align="center"
                        label-class-name  = 'title'
                       prop="class_address" />
                       <el-table-column label="家长要求"
                       align="center"
                        label-class-name  = 'title'
                       prop="yaoqiu" />
                       <el-table-column label="老师薪酬"
                       align="center"
                        label-class-name  = 'title'
                       prop="teacher_money" />
                       <!-- <el-table-column label="订单状态"
                       align="center"
                        label-class-name  = 'title'
                       :formatter ='stateTrans'
                       prop="state" />                -->

        <!-- <el-table-column label="数量"
                       align="center"
                       prop="num" />
      <el-table-column label="类型"
                       align="center"
                       prop="type"
                       :formatter="transType"> -->

      <!-- </el-table-column> -->

      <!-- <el-table-column label="操作地点" align="center" prop="operLocation" :show-overflow-tooltip="true" /> -->
      <el-table-column label="发布日期"
                       align="center"
                       label-class-name  = 'title'
                       prop="create_time"
                      >
      </el-table-column>
      <el-table-column label="预约老师"
                       align="center"
                       label-class-name  = 'title'
                       prop="teachername"
                       >
      </el-table-column>
      <el-table-column label="老师编号"
                       align="center"
                       label-class-name  = 'title'
                       prop="userid"
                       >
      </el-table-column>
      <el-table-column label="老师备注"
                       align="center"
                       label-class-name  = 'title'
                       prop="mark"
                       >
      </el-table-column>
      <el-table-column label="预约时间"
                       align="center"
                       label-class-name  = 'title'
                       prop="record_time"
                       >
      </el-table-column>
      <el-table-column label="订单状态"
                       align="center"
                        label-class-name  = 'title'
                       :formatter ='stateTrans'
                       prop="state" />  
      <el-table-column label="操作"
                       align="center"
                       label-class-name  = 'title'
                       class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button v-if="scope.row.state == '1'" class="inspect-button"
                     size="mini"
                     type="primary"
                     @click="access(scope.row)">分配</el-button>
          <!-- <el-button v-if="scope.row.judge == '0' && scope.row.state == '1'" class="inspect-button"
                     size="mini"
                     type="primary"
                     @click="handleJudge(scope.row)">评价</el-button>
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-view"
                     @click="handleView(scope.row)">查看</el-button>
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-updata"
                     @click="handleUpdate(scope.row)">修改</el-button>
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-delete"
                     @click="handleDelete(scope.row.id)">删除</el-button> -->
        </template>
      </el-table-column>

    </el-table>
    <el-pagination
      v-show="total>0"
      :total="total"
      @current-change="getList"
      @prev-click = 'getList'
      @next-click="getList"
    />

    <!-- 操作日志详细 -->
    <el-dialog title="详情"
               :visible.sync="open"
               :close-on-click-modal="false"
               width="700px"
               append-to-body>
      <el-form ref="form"
               :model="form"
               label-width="100px"
               size="mini">
        <el-row>
          <el-col :span="12">
            <el-form-item label="求助内容">
              <el-input v-model="form.content"
                        :disabled='disabled'
                        clearable
                        size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在地区">
              <el-input v-model="form.address"
                        :disabled='disabled'
                        clearable
                        size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式">
              <el-input v-model="form.phone"
                        :disabled='disabled'
                        clearable
                        size="small" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :disabled='disabled'
                   @click="submit">确定</el-button>
        <el-button @click="open = false">关闭</el-button>
      </div>
    </el-dialog>


        <!-- 操作日志详细 -->
        <el-dialog title="评价"
               :visible.sync="judgeOpen"
               :close-on-click-modal="false"
               width="500px"
               append-to-body>
      <el-form ref="form"
               :model="form"
               label-width="100px"
               size="mini">
        <el-row>
          <el-col :span="24">
            <el-form-item label="求助内容">
              <el-switch
  style="display: block"
  v-model="judge"
  active-color="#13ce66"
  inactive-color="#ff4949"
  active-text="好评"
  inactive-text="差评">
</el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="评价内容">
              <el-input v-model="form.judge_content"
                        :disabled='disabled'
                        clearable
                        size="small" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :disabled='disabled'
                   @click="judgeSubmit">确定</el-button>
        <el-button @click="judgeOpen = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { infoAdd,infoList,updateInfo,deleteInfo,judge,recordList,orderUpdate, getProdetail, addProduct, deleletProdcut, updateProduct } from '../api/productManage/index'
export default {
  name: 'Operlog',
  data () {
    return {
      nianji: [{
				key: '00',
				lable: '学前'
			},
			{
				key: '01',
				lable: '一年级'
			},
			{
				key: '02',
				lable: '二年级'
			},
			{
				key: '03',
				lable: '三年级'
			},
			{
				key: '04',
				lable: '四年级'
			},
			{
				key: '05',
				lable: '五年级'
			},
			{
				key: '06',
				lable: '六年级'
			},

			{
				key: '07',
				lable: '初一'
			},
			{
				key: '08',
				lable: '初二'
			},
			{
				key: '09',
				lable: '初三'
			},
			{
				key: '10',
				lable: '高一'
			},
			{
				key: '11',
				lable: '高二'
			},
			{
				key: '12',
				lable: '高三'
			},
			{
				key: '13',
				lable: '大学'
			},
			{
				key: '14',
				lable: '其他'
			}
		],
      score:'0',
      judge: true,
      pageIndex:1,
      pageSize:10,
      // 禁用状态
      disabled: false,
      queryParams: {},
      loading: false,
      // table 列表数据
      list: [],
      // 总条数
      total:0,
      // dialog 弹框
      open: false,
      judgeOpen:false,
      // 弹框 表单
      form: {}
    }
  },
  created () {
    this.handleQuery();
  },
  methods: {
    // 翻译性别
    transOrder (row) {
      return  row.id
    },
     // 翻译性别
     transGender (row) {
      return row.gender == '1' ? '男' :'女'
    },
    // 翻译求助状态
    stateTrans (row) {
      let obj = {
        "0":'待审核',
        "1":'待分配',
        '2':'已分配'
      }
      return obj[row.state]
    },
    // 翻译评价类型
    transGrade (row) {
      let list = this.nianji;
      for(let i=0;i<list.length;i++){
        if(list[i].key-0 == row.grade){
          return list[i].lable
        }
      }
      
    },
    access(row){
      let params = {
        id:row.id,
        state:'2',
        teacher_id:row.openid
      }
      debugger
      this.$confirm('确认分配吗？')
          .then(()=> {
            orderUpdate(params).then(res => {
        this.handleQuery()
      })
          })
          .catch(_ => {});
      
     

    },
    //  退出
    logout(){
      localStorage.clear();
      this.$router.push('/')
    },
    // 新增按钮
    handleAdd () {
      this.open = true
      this.disableFun(false)
      this.form.id = undefined
    },
    // 确定按钮
    submit () {
      console.log(this.form)
      if (!this.form.id) {
        let userid = localStorage.getItem('userid');
        if(!this.form.content){
          return this.$message.error('请输入求助内容');
        }
        if(!this.form.address){
          return this.$message.error('请输入地址');
        }
        if(!this.form.phone){
          return this.$message.error('请输入联系方式');
        }
        if(this.form.phone.length != 11){
          return this.$message.error('请输入11位联系方式');
        }
        this.form.userid = userid
        infoAdd(this.form).then(res => {
         if(res.code == '200'){
          this.$message.success('新增成功')
          this.open = false
          this.handleQuery()
         }else{
          this.$message.error('服务异常');
         }

        })
      } else {
        updateInfo(this.form).then(res => {
          console.log(res)
          this.open = false
          this.$message.success('修改成功')
          debugger
          this.handleQuery()
        })
      }
    },
        // 查看
        handleJudge (row) {
          debugger
      this.judgeOpen = true
      this.form.id = row.id
      this.form.help_userid = row.help_userid

    },
       // 确定按钮
       judgeSubmit () {
      console.log(this.form)
      if(this.judge){
        this.form.judge = '1'
      }else{
        this.form.judge = '2'
      }
      if(!this.form.judge_content){
       return this.$message.error('请添加评价')
      }
      judge(this.form).then(res => {
          console.log(res)
          this.open = false
          this.$message.success('评价成功')
          this.judgeOpen = false
          this.handleQuery()
        })
      
    },
    // 查看
    handleView (row) {
      debugger
      this.open = true
      this.form = Object.assign({},row)
      this.disableFun(true)

    },
    // 修改按钮
    handleUpdate (row) {
      this.handleView(row)
      this.disableFun(false)
    },
    /**
     * @desc 禁用逻辑
     * @param {Blean}
    */
    disableFun (Blean) {
      this.disabled = Blean
    },
    // 查询按钮
    handleQuery () {
      let params= {
        pageIndex:this.pageIndex,
        pageSize:this.pageSize,
      }
      recordList(params).then(res => {
        debugger
        this.list = res.data.list;
        console.log(this.list)
        this.total = res.data.total
        console.log(this.total)
      })
    },
    // 删除按钮
    handleDelete (id) {
      let obj = { id: id }
      deleteInfo(obj).then(res => {
        this.$message.success('删除成功')
        this.handleQuery()
      })
    },
    //  上一页面
    preClick(e){
      debugger
      this.pageIndex = e;
      if(pageIndex<=1){return}
      this.handleQuery()
    },
    // 下一页
    preClick(){
      let pageIndex = this.pageIndex +1;
      
      if(pageIndex * this.pageSize >= this.total){
        return
      }
      this.pageIndex = pageIndex;
      this.handleQuery()
    },
    // 获取列表
    getList (e) {
      this.pageIndex = e
      let params = {
        pageIndex:this.pageIndex,
        pageSize:this.pageSize,
      }
      recordList(params).then(res => {
        debugger
        this.list = res.data.list;
        this.total = res.data.total
        console.log(this.total)
      })
    }
  }
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.gap{
  margin: 30px 10px;
}
.title{
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/infoManage/infoList.vue